import { connect } from 'react-redux'
import at from 'lodash/at'

import IssueCard from '../../components/issues/issue-card'

function mapStateToProps (state, ownProps) {
  const issue = state.issues[ownProps.issueId]
  const area = state.areas[issue.area]
  const issueDescription = state.issueDescriptions[issue.issueDescription]
  const submittedBy = state.users[issue.submittedBy]

  return { issue, area, issueDescription, submittedBy }
}

export default connect(mapStateToProps)(IssueCard)



// WEBPACK FOOTER //
// ./src/containers/issues/issue-card-container.js